import { __assign, __rest } from "tslib";
import React from 'react';
import './TreeSelectRC.less';
import RC_TreeSelect from 'rc-tree-select';
import { Icon } from 'antd';
var TreeSelectRC = function (props) {
    var children = props.children, dropdownClassName = props.dropdownClassName, useEUI = props.useEUI, others = __rest(props, ["children", "dropdownClassName", "useEUI"]);
    var prefixCls = useEUI ? 'eui-select' : 'ant-select';
    var renderSwitcher = function (prefixCls, _a) {
        var isLeaf = _a.isLeaf, loading = _a.loading;
        if (loading) {
            return React.createElement(Icon, { type: "loading", className: prefixCls + "-switcher-loading-icon" });
        }
        if (isLeaf) {
            return null;
        }
        return React.createElement(Icon, { type: "caret-down", className: prefixCls + "-switcher-icon" });
    };
    var inputIcon = React.createElement(Icon, { type: "down", className: prefixCls + "-arrow-icon" });
    var antdClassNameV = 'tree-select-rc ant-select-lg ant-select ant-select-enabled ant-select-allow-clear ant-select-selection';
    var euiClassNameV = 'tree-select-rc eui-select eui-select-enabled eui-select-allow-clear eui-select-selection';
    var dropdownWrapClassName = dropdownClassName ? dropdownClassName + " tree-select-dropdown-rc" : 'tree-select-dropdown-rc';
    return (React.createElement(RC_TreeSelect, __assign({}, others, { id: "TreeSelectRC_Ref", switcherIcon: function (switcherProps) { return renderSwitcher(prefixCls, switcherProps); }, inputIcon: inputIcon, removeIcon: React.createElement(Icon, { type: "close", className: prefixCls + "-remove-icon" }), clearIcon: React.createElement(Icon, { type: "close-circle", theme: "filled", className: prefixCls + "-clear-icon" }), prefixCls: prefixCls, showCheckedStrategy: 'SHOW_ALL', className: useEUI ? euiClassNameV : antdClassNameV, dropdownClassName: dropdownWrapClassName, listHeight: 280, virtual: true }), children));
};
export default TreeSelectRC;
